var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-base',{staticClass:"login-layout"},[_c('v-main',[_c('v-container',{staticClass:"wrapper d-flex align-center justify-center",attrs:{"fluid":"","fill-height":""}},[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }